import { flattenInstructions, resolveInstructionsSource } from '../../utils/parkingInstructions';

export function getDisplay(listing) {
    if (!listing) {
        return { name: 'Untitled draft', type: '', address: '' };
    }
    const addr = listing.addressData ?? {};
    return {
        name: listing.confirmedFields?.name
            || listing.enrichmentFields?.name?.value
            || listing.enrichmentFields?.name
            || addr.formatted_address
            || addr.formattedAddress
            || 'Untitled draft',
        type: listing.confirmedFields?.type
            || listing.enrichmentFields?.type?.value
            || listing.enrichmentFields?.type
            || '',
        address: addr.formatted_address
            || addr.formattedAddress
            || '',
    };
}

export function getListingName(listing) {
    return getDisplay(listing).name;
}

export function getListingType(listing) {
    return getDisplay(listing).type;
}

export function getListingAddress(listing) {
    return getDisplay(listing).address;
}

export function getRowSpots(listing) {
    if (!listing) return null;
    if (listing.pricing?.maxSpots != null) return listing.pricing.maxSpots;

    const enriched = listing.enrichmentFields?.geoSpaceCount;
    if (enriched && typeof enriched === 'object') {
        if (enriched.suggestedCount != null) return enriched.suggestedCount;
        if (enriched.value != null) return enriched.value;
    }
    if (typeof listing.geoSpaceCount === 'number') return listing.geoSpaceCount;
    return null;
}

export function getAiSpaceCount(listing) {
    if (!listing) return null;
    const enriched = listing.enrichmentFields?.geoSpaceCount;
    if (enriched && typeof enriched === 'object') {
        if (enriched.suggestedCount != null) return enriched.suggestedCount;
        if (enriched.value != null) return enriched.value;
    }
    if (typeof listing.geoSpaceCount === 'number') return listing.geoSpaceCount;
    if (listing.geoSpaceCount && typeof listing.geoSpaceCount === 'object') {
        return listing.geoSpaceCount.suggestedCount ?? listing.geoSpaceCount.value ?? null;
    }
    return null;
}

export function getRowRate(listing) {
    return listing?.pricing?.hourlyRate ?? null;
}

export function getInstructions(listing) {
    if (!listing) return '';
    // resolveInstructionsSource (parkingInstructions.js) is the shared
    // legacy-shape unwrap already used by listingToProperty.js /
    // listingApprovalAdapter.js / PropertyApprovalPage.jsx — this was the
    // 4th hand-rolled copy of the same conditional (Sabutobi, PR #368).
    return flattenInstructions(resolveInstructionsSource(listing));
}
